interface MatchListCardProps {
  value1: string | number | undefined;
  value2: string | number | undefined;
  text1: string;
  text2?: string;
}

function MatchListCard({ value1 = '', value2 = '', text1 = '', text2 = '' }: MatchListCardProps) {
  return (
    <div className='flex min-h-[110px] flex-wrap border-b py-2 sm:flex-nowrap'>
      <div className='order-2 flex w-1/2 items-center justify-center p-2 font-bold sm:order-1 sm:w-1/3 sm:p-0'>
        <span>{value1}</span>
      </div>
      <div className='order-1 flex w-full flex-col items-center justify-center p-2 text-center sm:order-2  sm:w-1/3 sm:p-0'>
        <h5 className='font-bold'>{text1}</h5>
        <h6 className='text-xs'>{text2}</h6>
      </div>
      <div className='order-2 flex w-1/2 items-center justify-center p-2 font-bold sm:order-3 sm:w-1/3  sm:p-0'>
        <span>{value2}</span>
      </div>
    </div>
  );
}

export default MatchListCard;
